import Vue from 'vue'
import VueRouter from 'vue-router'
import home from '@/pages/Home'
import joum_info from '@/pages/joum_info'
import caozuo from '@/pages/caozuo'
import login from '@/pages/account/login'
import register from '@/pages/account/register'
import RetrievePwd from '@/pages/account/RetrievePwd'
import registerSuccess from '@/pages/account/registerSuccess'
import user from '@/pages/user/index'
import userhome from '@/pages/user/userhome'
import MallCenter from '@/pages/user/MallCenter'
import MallCenter1 from '@/pages/MallCenter'
import Myorder from '@/pages/user/Myorder'
import address from '@/pages/user/address'
import RetrievePWD from '@/pages/user/RetrievePWD'
import Mymessage from '@/pages/user/Mymessage'
import userinfo from '@/pages/user/userinfo'
import HelpCenter from '@/pages/user/HelpCenter'
import PlaceOrder from '@/pages/user/PlaceOrder'
import Submit from '@/pages/user/Submit'
import order_info from '@/pages/user/order_info'
Vue.use(VueRouter)

// mode:'history'
const router = new VueRouter({
  base:'/h5/',
  routes: [
    {
      path: '/div1',
      component: home,
    },
    {
      path: '/div2',
      component: home
    },
    {
      path: '/div3',
      component: home
    },
    {
      path: '/',
      component: home
    },
    {
      path: '/joum_info',
      component: joum_info
    },
    {
      path: '/MallCenter',
      component: MallCenter1
    },
	{
	  path: '/MallCenter',
	  component: MallCenter1
	},
    {
      path: '/caozuo',
      component: caozuo
    },
    {
      path: '/account/login',
      component: login
    },
    {
      path: '/account/RetrievePwd',
      component: RetrievePwd
    },
    {
      path: '/account/register',
      component: register
    },
    {
      path: '/account/registerSuccess',
      component: registerSuccess
    },
    {
      path: '/user/userhome',
      component: user,
      children: [
        {
          path: '/user/userhome',
          component: userhome,
        },
        {
          path: '/user/userinfo',
          component: userinfo,
        },
        {
          path: '/user/MallCenter',
          component: MallCenter,
        },
        {
          path: '/user/Myorder',
          component: Myorder,
        },
        {
          path: '/user/address',
          component: address,
        },
        {
          path: '/user/RetrievePWD',
          component: RetrievePWD,
        },
        {
          path: '/user/Mymessage',
          component: Mymessage,
        },
        {
          path: '/user/HelpCenter',
          component: HelpCenter,
        }
      ]
    },
    {
      path: '/PlaceOrder',
      component: PlaceOrder

    },
    {
      path: '/Submit',
      component: Submit

    },
    {
      path: '/user/order_info',
      component: order_info

    }



  ]
})



export default router